import React, { Component } from 'react';
import { Table, Jumbotron, Container, Row, Col, Button, Alert, Form } from 'react-bootstrap';
// ;
import config from '../../../config';
import funciones from '../../../middleware/funciones';
import ModalConfirm from '../../subcomponent/modalConfirm';


export class generadorPlano extends Component {
    constructor(props) {
        super(props);
        const currentCompany = sessionStorage.getItem('company');
        const currentUserType = sessionStorage.getItem('tipo');
        this.state = {
            documentos: [],
            documentos_detalle: [],
            documentSelected: [],
            detalleSelected: [],
            tipos_documento: [],
            bodegas: [],
            estados: [],
            empresa: currentCompany,
            tipo: currentUserType,
            searchTipo: "",
            searchNombreCliente: "",
            searchNumero: "",
            searchCliente: "",
            searchVendedor: "",
            bodega: "",
            isAllChecked: false,
            selectPrefijo: ""
        };
    }
    componentDidMount() {
        this.updateInfo();
    }


    buscar = ({ target }) => {
        const { name, value } = target;
        this.setState({ [name]: value });
    };

    hideAllDetail = () => {
        const { documentos } = this.state;
        //const { documentos_detalle } = this.state;
        documentos.forEach(element => {
            const row = document.getElementById(element.ID_PEDIDOS);
            row.style.display = 'none';
            const boxCab = document.getElementById("checkcab" + element.ID_PEDIDOS);
            boxCab.checked = false;
            /* documentos_detalle.forEach(detail => {
                if (element.TIPO_DOCUMENTO_CABECERA === detail.TIPO_DOCUMENTO_DETALLE
                    && element.NUMERO_FACTURA_CABECERA === detail.NUMERO_FACTURA_DETALLE) {
                    const box = document.getElementById(element.ID_PEDIDOS + "-" + detail.INDICE_ITEM);
                    box.checked = false;
                }
            }); */
        });
    }

    addOrder = (data, { target }) => {
        const row = document.getElementById(data.ID_PEDIDOS);
        row.style.display = '';

        for (let index = 1; true; index++) {
            const box = document.getElementById(data.ID_PEDIDOS + "-" + index);
            if (!box) break;
            box.checked = target.checked;
        };

        this.checkedList();
    }

    updateInfo = () => {
        const { empresa } = this.state
        const { tipo } = this.state

        const datasend = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'empresa': empresa,
                'tipo': tipo
            }
        }
        fetch(config.servBackEnd + '/invoice/listorders', datasend)
            .then(res => res.json())
            .then((data) => {
                if (data.ok) {
                    const datos = data.data;
                    const pedido = datos[0];
                    const detalles = datos[1];
                    const tipos_documento = datos[2];
                    const bodegas = datos[3];
                    this.setState({
                        documentos: pedido,
                        documentos_detalle: detalles,
                        tipos_documento,
                        bodegas
                    });
                    this.hideAllDetail();
                }
            })
            .catch((error) => console.error(error))
    }

    handleSubmit = (event) => {
        event.preventDefault();
        this.setState({ show: true });
    }

    processInfo = () => {
        const { documentSelected } = this.state;
        const { empresa } = this.state
        const datasend = {
            method: 'POST',
            body: JSON.stringify(documentSelected),
            headers: {
                'Content-Type': 'application/json',
                'empresa': empresa,
            }
        }
        fetch(config.servBackEnd + '/invoice/changestate/', datasend)
            .then(response => response.json())
            .then(data => {
                this.updateInfo();
            })
    }

    enviarInfo = () => {
        this.setState({ show: false });
        const { empresa } = this.state;
        const { tipo, bodega } = this.state;
        const { documentSelected } = this.state;
        const { detalleSelected } = this.state;
        const { selectPrefijo } = this.state;
        const info = {
            list: documentSelected,
            listDetail: detalleSelected,
            prefijo: selectPrefijo,
            bodega
        }

        const datasend = {
            method: 'POST',
            body: JSON.stringify(info),
            headers: {
                'Content-Type': 'application/json',
                'empresa': empresa,
                'tipo': tipo
            }
        }
        fetch(config.servBackEnd + '/invoice/convertorder', datasend)
            .then(res => res.json())
            .then((data) => {
                this.updateInfo();
                ////console.log(data);
            })
            .catch((error) => console.error(error))

    }

    showDetail = (data) => {
        const row = document.getElementById(data.ID_PEDIDOS);
        row.style.display = (row.style.display) ? '' : 'none';
    }

    addItem = (data, { target }) => {
        const { id } = target;
        const ID_PED = id.substring(0, id.search("-"));

        let cont = 0;
        for (let index = 1; true; index++) {
            const box = document.getElementById(ID_PED + "-" + index);
            if (!box) break;
            if (box.checked) cont++;
        };

        const boxCab = document.getElementById("checkcab" + ID_PED);

        if (cont === 0) {
            boxCab.checked = false;
        } else {
            boxCab.checked = true;
        }

        this.checkedList();
    }
    checkedList = () => {
        const { documentos } = this.state;
        const { documentos_detalle } = this.state;

        const documentSelected = [];
        const detalleSelected = [];

        documentos.forEach((element) => {
            const boxCab = document.getElementById("checkcab" + element.ID_PEDIDOS);
            if (boxCab.checked) documentSelected.push(element.ID_PEDIDOS);
            documentos_detalle.forEach(detail => {
                if (element.TIPO_DOCUMENTO_CABECERA === detail.TIPO_DOCUMENTO_DETALLE
                    && element.NUMERO_FACTURA_CABECERA === detail.NUMERO_FACTURA_DETALLE) {
                    //const box = document.getElementById(element.ID_PEDIDOS + "-" + detail.INDICE_ITEM);
                    ////console.log(element.ID_PEDIDOS + "-" + detail.INDICE_ITEM);
                    if (boxCab.checked) {
                        //const cantbox = document.getElementById("cant" + element.ID_PEDIDOS + "-" + detail.INDICE_ITEM);
                        //detail.CANTIDAD_FACTURADA = (cantbox.value === "") ? 0 : cantbox.value;
                        detalleSelected.push(detail.ID_DETALLE);
                    }
                }
            });
        });

        this.setState({
            documentSelected,
            detalleSelected
        })

    }

    handleClose = () => {
        this.setState({ show: false });
    };


    render() {
        const facturas = this.state.documentos;
        const { tipos_documento } = this.state;
        const { documentos_detalle } = this.state;
        const { searchTipo } = this.state;
        const { searchNombreCliente } = this.state;
        const { searchNumero } = this.state;
        const { searchCliente } = this.state;
        const { searchVendedor } = this.state;
        const { documentSelected } = this.state;
        const { bodegas } = this.state;
        const addOrder = this.addOrder;
        const showDetail = this.showDetail;
        const processInfo = this.processInfo;
        const mensajeConfirm = '¿Esta seguro que desea facturar el pedido?';
        //const addItem = this.addItem;
        //const checkedList = this.checkedList;
        return (
            <div className="contenedor">

                <div>
                    <ModalConfirm show={this.state.show} enviarInfo={this.enviarInfo} handleClose={this.handleClose} mensaje={mensajeConfirm} ></ModalConfirm>
                </div>
                <Jumbotron>
                    <h1>PEDIDOS A FACTURAS</h1>
                </Jumbotron>
                <div>
                    <Container fluid>
                        <Form onSubmit={this.handleSubmit}>
                            <Row>
                                <Col>
                                    DOCUMENTO FACTURA
                                </Col>
                                <Col>
                                    <Form.Group controlId="tipodoc">
                                        <Form.Control as="select" onChange={(e) => { this.setState({ selectPrefijo: e.target.value }) }} required>
                                            <option value="">Seleccione</option>
                                            {
                                                tipos_documento.map((element, i) => {
                                                    return (<option key={"td" + i} value={element.PREFIJO}>{element.PREFIJO}</option>);
                                                })
                                            }
                                        </Form.Control>
                                    </Form.Group>
                                </Col>

                                <Col>
                                    BODEGA
                                </Col>
                                <Col>
                                    <Form.Group controlId="tipodoc">
                                        <Form.Control as="select" onChange={(e) => { this.setState({ bodega: e.target.value }) }} required>
                                            <option value="">Seleccione</option>
                                            {
                                                bodegas.map((element, i) => {
                                                    return (<option key={"td" + i} value={element.ID_BODEGAS}>{element.DESCRIPCION_BODEGA}</option>);
                                                })
                                            }
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                                {documentSelected.length !== 0 && <Col><Button type="submit">Convertir a factura</Button></Col>}
                                {documentSelected.length !== 0 && <Col><Button onClick={processInfo}>Dar por cumplido</Button></Col>}
                                {documentSelected.length === 0 && <Col><Alert variant="danger"> Seleccione al menos un pedido</Alert></Col>}
                            </Row>
                            <Row>
                                <Table hover bordered responsive size="sm" className="table">
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th></th>
                                            <th><input type="text" maxLength="2" size="3" name="searchTipo" onChange={this.buscar} /></th>
                                            <th><input type="text" maxLength="4" size="5" name="searchNumero" onChange={this.buscar} /></th>
                                            <th><input type="text" maxLength="10" size="11" name="searchCliente" onChange={this.buscar} /></th>
                                            <th><input type="text" maxLength="10" size="11" name="searchNombreCliente" onChange={this.buscar} /></th>
                                            <th><input type="text" maxLength="10" size="11" name="searchVendedor" onChange={this.buscar} /></th>
                                        </tr>
                                    </thead>
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th>Fecha Documento</th>
                                            <th>Tipo Documento</th>
                                            <th>Numero Documento</th>
                                            <th>Codigo Cliente</th>
                                            <th>Nombre Cliente</th>
                                            <th>Vendedor</th>
                                        </tr>
                                    </thead>
                                    {facturas.map(function (currentData, index) {
                                        if (currentData.TIPO_DOCUMENTO_CABECERA.toLowerCase().search(searchTipo.toLowerCase()) > -1
                                            && currentData.NOMBRE_CLIENTE.toLowerCase().search(searchNombreCliente.toLowerCase()) > -1
                                            && currentData.NUMERO_FACTURA_CABECERA.toLowerCase().search(searchNumero.toLowerCase()) > -1
                                            && currentData.DOCUMENTO_CLIENTE.toLowerCase().search(searchCliente.toLowerCase()) > -1
                                            && currentData.VENDEDOR.toLowerCase().search(searchVendedor.toLowerCase()) > -1
                                        ) {
                                            return <tbody key={"c" + index}>
                                                <tr onClick={() => showDetail(currentData)}>
                                                    <td><input id={"checkcab" + currentData.ID_PEDIDOS} type="checkbox" onChange={(e) => addOrder(currentData, e)} /></td>
                                                    <td name="fecha">{funciones.formatDate(currentData.FECHA_DOCUMENTO)}</td>
                                                    <td name="tipo">{currentData.TIPO_DOCUMENTO_CABECERA}</td>
                                                    <td name="dian">{currentData.NUMERO_FACTURA_CABECERA}</td>
                                                    <td name="numero">{currentData.DOCUMENTO_CLIENTE}</td>
                                                    <td name="cliente">{currentData.NOMBRE_CLIENTE}</td>
                                                    <td name="cliente">{currentData.VENDEDOR}</td>
                                                </tr>
                                                <tr id={currentData.ID_PEDIDOS}>
                                                    <td></td>
                                                    <td colSpan="6">
                                                        <Table hover bordered responsive size="sm" className="table">
                                                            <thead>
                                                                <tr>
                                                                    <th>Descripcion</th>
                                                                    <th>Cantidad Pedida</th>
                                                                    {/* <th>Cantidad Facturada</th>
                                                                    <th>Cantidad a Facturar</th> */}
                                                                    <th>Precio</th>
                                                                    <th>Dscto</th>
                                                                    <th>IVA</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {documentos_detalle.map((element, i) => {
                                                                    if (currentData.TIPO_DOCUMENTO_CABECERA === element.TIPO_DOCUMENTO_DETALLE
                                                                        && currentData.NUMERO_FACTURA_CABECERA === element.NUMERO_FACTURA_DETALLE) {
                                                                        return <tr key={"d" + element.ID_DETALLE}>
                                                                            {/* <td><input value={element.ID_DETALLE} id={currentData.ID_PEDIDOS + "-" + element.INDICE_ITEM} type="checkbox" onChange={(e) => addItem(element, e)} /></td> */}
                                                                            <td>{element.ITEM_DESCRIPCION}</td>
                                                                            <td>{element.CANTIDAD_1}</td>
                                                                            {/* <td>{element.CANTIDAD_FACTURADA}</td>
                                                                            <td><input max={element.CANTIDAD_1} type="number" id={"cant" + currentData.ID_PEDIDOS + "-" + element.INDICE_ITEM} onChange={checkedList} /></td> */}
                                                                            <td>{element.PRECIO_UNITARIO_DETALLE}</td>
                                                                            <td>{element.DESCUENTO_LINEA_DETALLE}</td>
                                                                            <td>{element.IVA_DETALLE}</td>
                                                                        </tr>;
                                                                    } else {
                                                                        return null;
                                                                    }
                                                                })}
                                                            </tbody>
                                                        </Table>
                                                    </td>
                                                </tr>
                                            </tbody>;
                                        } else {
                                            return null;
                                        }
                                    })}
                                </Table>
                            </Row>
                        </Form>
                    </Container>
                </div>

            </div>
        )
    }
}

export default generadorPlano



// WEBPACK FOOTER //
// ./src/components/bussines/pedidos/convertidorFacturas.jsx